import * as React from 'react';
import { PreventUserSelectSansCursor } from '../styles/PreventUserSelect';
import { ImgAttrs } from '../utils/HtmlAttrs';
import { typedKeys } from '../utils/TypedKeys';
import { Img } from '../widgets/DomWidgets';
import { IconDropdownArrowSvg } from './resources/IconDropdownArrow';

export const IconStyle: React.CSSProperties = {
  ...PreventUserSelectSansCursor,
  flexShrink: 0,
};

export interface IconState {
  active?: boolean;
  checked?: boolean;
  disabled?: boolean;
  focus?: boolean;
  hover?: boolean;
  onDarkBackground?: boolean;
}

export type IconLibraryIcon = (props: { alt?: string, size: number, color?: string }) => React.ReactSVGElement | null;

const svgDataUriRegExp = /^data:image\/svg\+xml/;
/**
 * Encodes a raw SVG file (i.e. a string that looks like `<svg ...`) into a data URI,
 * which can then be used as a `src` for `<img>` elements, CSS `background-image`, etc.
 *
 * If the provided string is already encoded, no-op.
 */
export function encodeSvg(svg: string): string {
  return svgDataUriRegExp.test(svg) ? svg : `data:image/svg+xml,${encodeURIComponent(svg)}`;
}

/** This is only applicable to our remaining local string-replace icons found in src/icons/resources */
function formatSvg(svgImport: string, state: IconState = {}): string {
  const classList = typedKeys<IconState>(state).filter(key => !!(state)[key]).join(' ');
  return encodeSvg(svgImport.replace('$state$', classList));
}

const IconDropdownArrowIconElement: React.FC<Pick<IconState, 'active' | 'hover' | 'disabled' | 'onDarkBackground'> & ImgAttrs> = props => {
  const { active, className, disabled, hover, onDarkBackground, ...svgProps } = props;

  return <Img
    {...svgProps}
    // This change will increase the size of DropdownButtonType.Icon instances by 4px, so waiting to push it out.
    // const IconDropdownArrowSvg = ArrowTriangleDownIconRaw(12, TabStyles.Colors.L8);
    src={formatSvg(IconDropdownArrowSvg, { active, disabled, hover, onDarkBackground })}
  />;
};

export const IconDropdownArrowIcon = {
  height: 5,
  width: 7,
  icon: IconDropdownArrowIconElement,
};
